<template>
  <section v-if="show" class="access_devices__modal">
    <section class="access_devices__modal--container">

      <p class="access_devices__modal--text">
        ¿Está seguro que desea notificar el pago de la administración a este usuario?
      </p>
      <p>{{payment.sublocation}}</p>
      <div class="access_devices__modal--buttons">
        <div class="access_devices__modal--button" @click="cancel">Cancelar</div>
        <div class="access_devices__modal--button active" @click="confirm(payment)" >Si</div>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    select_option: {
      type: Boolean,
      required: true
    },
    payment: {
      type: Object,
      required: true
    }
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    confirm(payment) {
      this.$emit('confirm', payment);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/views/users/payment_status/Modals/ConfirmModal.vue